// extracted by mini-css-extract-plugin
export default {"wrapper":"checkbox_wrapper__FA9V7","inscription":"checkbox_inscription__Di3Y7","input":"checkbox_input__JOYmm"};